import { render } from "./ProductDetailsPage.vue?vue&type=template&id=5fa29a92&scoped=true&ts=true"
import script from "./ProductDetailsPage.vue?vue&type=script&lang=ts"
export * from "./ProductDetailsPage.vue?vue&type=script&lang=ts"

import "./ProductDetailsPage.vue?vue&type=style&index=0&id=5fa29a92&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fa29a92"]])

export default __exports__